module.exports = __webpack_public_path__ + "media/introvideo.78f7484f.mp4";